module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-feed"
    }
  }, [(_vm.gotInitialLoggedUserInfo) ? _c('article', {
    attrs: {
      "id": "feed-posts-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "feed-post-collection"
    }
  }, [(_vm.layout === 'masonry') ? _c('vue-masonry', {
    attrs: {
      "min-width": 450,
      "horizontal-gutter": 40,
      "vertical-gutter": 40
    }
  }, [(Object.keys(_vm.feedPosts || {}).length > 0) ? [_vm._l((_vm.feedPosts), function(feedPost) {
    return [(feedPost.type === 'singlePost') ? _c('feed-status-post', {
      key: feedPost.post.id,
      attrs: {
        "data": feedPost.post
      }
    }) : _vm._e(), _vm._v(" "), (feedPost.type === 'groupPost') ? _c('group-post', {
      attrs: {
        "posts": feedPost.posts
      }
    }) : _vm._e()]
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.layout === 'single') ? _c('div', {
    staticClass: "single-column-container"
  }, [(Object.keys(_vm.feedPosts || {}).length > 0) ? [_vm._l((_vm.feedPosts), function(feedPost) {
    return [(feedPost.type === 'singlePost') ? _c('feed-status-post', {
      key: feedPost.id,
      attrs: {
        "data": feedPost.post
      }
    }) : _vm._e(), _vm._v(" "), (feedPost.type === 'groupPost') ? _c('group-post', {
      attrs: {
        "posts": feedPost.posts
      }
    }) : _vm._e()]
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.layout === 'double') ? _c('div', {
    staticClass: "double-column-container"
  }, [_c('vue-masonry', {
    attrs: {
      "min-width": 500,
      "horizontal-gutter": 40,
      "vertical-gutter": 40
    }
  }, [(Object.keys(_vm.feedPosts || {}).length > 0) ? [_vm._l((_vm.feedPosts), function(feedPost) {
    return [(feedPost.type === 'singlePost') ? _c('feed-status-post', {
      key: feedPost.id,
      attrs: {
        "data": feedPost.post
      }
    }) : _vm._e(), _vm._v(" "), (feedPost.type === 'groupPost') ? _c('group-post', {
      attrs: {
        "posts": feedPost.posts
      }
    }) : _vm._e()]
  })] : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "load-more-button-container"
  }, [(_vm.fetchingStatus === 'fetched' && Object.keys(_vm.feedPosts || {}).length > 0 && !_vm.hasFetchedAll) ? _c('button', {
    attrs: {
      "id": "feed-fetch-more"
    },
    on: {
      "click": _vm.getPosts
    }
  }, [_vm._v("Load more posts")]) : _vm._e(), _vm._v(" "), (_vm.fetchingStatus === 'fetching') ? _c('loader-large') : _vm._e()], 1)], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75ae8c58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/MediaFeed/MediaFeed.vue
// module id = 892
// module chunks = 2